"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sectionConfig = exports.currentSectionName = void 0;
const widgetsNames_1 = require("./widgetsNames");
const helper_1 = require("../../common/helper");
const helpers_1 = require("evolution-common/lib/utils/helpers");
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const customHelpers_1 = require("../../common/customHelpers");
exports.currentSectionName = 'selectPerson';
const previousSectionName = 'personsTrips';
const nextSectionName = 'tripsIntro';
// Config for the section
exports.sectionConfig = {
    previousSection: previousSectionName,
    nextSection: nextSectionName,
    title: {
        fr: 'Sélection du membre du ménage',
        en: 'Household member selection'
    },
    widgets: widgetsNames_1.widgetsNames,
    // Allow to click on the section menu
    enableConditional: function (interview) {
        return (0, helper_1.householdMembersSectionComplete)(interview);
    },
    isSectionCompleted: (interview, _iterationContext) => {
        // Completed if there is an active person ID set
        const activePersonId = (0, helpers_1.getResponse)(interview, '_activePersonId');
        return !(0, LodashExtensions_1._isBlank)(activePersonId);
    },
    onSectionEntry: customHelpers_1.updateHouseholdSizeFromPersonCount
};
exports.default = exports.sectionConfig;
